import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import CryptoJS from "crypto-js";
import LZString from "lz-string";

import { useReactToPrint } from "react-to-print";
import { fetchVehiculesbyserie } from "../api/api";
import { fetchVehiculesbyid } from "../api/api";
import "./print.css";

export default function QRCodeGenerator() {
  const SECRET_KEY = "HONNEUR_DE_LA_PATRIE"; //  clé secrète

  const encryptData = (input) => {
    const buildMinimal = (source) => {
      const minimal = {
        n: source?.nom,
        p: source?.prenom,
        f: source?.franchise,
        k: source?.numero_serie_plaque,
        c: source?.chassis,
        co: source?.couleur,
        u: source?.usage,
        t: source?.type ?? source?.type_vehicule,
      };
      return Object.fromEntries(
        Object.entries(minimal).filter(([, v]) => v !== undefined && v !== null)
      );
    };

    const uint8ArrayToWordArray = (u8Array) => {
      const words = [];
      for (let i = 0; i < u8Array.length; i += 4) {
        words.push(
          ((u8Array[i] || 0) << 24) |
            ((u8Array[i + 1] || 0) << 16) |
            ((u8Array[i + 2] || 0) << 8) |
            (u8Array[i + 3] || 0)
        );
      }
      return CryptoJS.lib.WordArray.create(words, u8Array.length);
    };

    const toBase64Url = (b64) =>
      b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");

    const minimal = buildMinimal(input);
    const json = JSON.stringify(minimal);
    const compressed = LZString.compressToUint8Array(json);
    const wordArray = uint8ArrayToWordArray(compressed);
    const cipherB64 = CryptoJS.AES.encrypt(wordArray, SECRET_KEY).toString();
    return toBase64Url(cipherB64);
  };
  const contentRef = useRef(null);
  //const { numeroSerie } = useParams(); // Récupération du paramètre depuis l'URL
  const { id } = useParams(); // Récupération du paramètre depuis l'URL

  const handlePrint = useReactToPrint({ contentRef });

  const [vehicules, setVehicules] = useState([]);
  const [numeroSerie, setNumeroserie] = useState("");
  const [agentInfo, setAgentInfo] = useState(null);
  const encryptedData = encryptData(vehicules);
  // const navigate = useNavigate();

  // Fonction pour récupérer les informations de l'agent enregistreur
  const fetchAgentInfo = async (id_enregistreur) => {
    if (!id_enregistreur) return;

    try {
      const response = await fetch(`https://srv968119.hstgr.cloud/users/${id_enregistreur}`);
      if (response.ok) {
        const agentData = await response.json();
        setAgentInfo(agentData);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des informations de l'agent:", error);
    }
  };

  // Fonction pour rafraîchir la liste des véhicules
  const refreshVehiculesserie = async () => {
    //  const updatedVehicules = await fetchVehiculesbyserie(numeroSerie);
    const updatedVehicules = await fetchVehiculesbyid(id);
    setVehicules(updatedVehicules);
    setNumeroserie(updatedVehicules.numero_serie);

    // Récupérer les informations de l'agent si id_enregistreur existe
    if (updatedVehicules.id_enregistreur) {
      fetchAgentInfo(updatedVehicules.id_enregistreur);
    }
  };

  useEffect(() => {
    refreshVehiculesserie(id);
  }, []);

  return (
    <div className="ml-[5%] w-[90%] h-[100%] flex flex-col items-center text-black absolute mt-[15%]  p-3">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/niger22.jpg')",
        }}
      ></div>
      <div className="relative w-[100%] justify-between overflow-y-scroll  p-2 rounded-md text-black bg-opacity-95">
        <div className="flex flex-row w-[100%] justify-between pt-11 items-start gap-4 p-4 border rounded-lg shadow-lg bg-white bg-opacity-70">
          <div>
            <h2 className="text-xl font-bold">INFORMATIONS DU PROPRIÉTAIRE</h2>
            <p className="text-md font-medium flex flex-row">
              NOM : <b>{vehicules.nom?.toUpperCase()}</b>
              <p className="text-md font-medium ml-6">
                TV12 : <b>{vehicules.id_vehicule?.toString().toUpperCase()}</b>
              </p>
            </p>
            <p className="text-md font-medium">
              PRÉNOM : <b>{vehicules.prenom?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              TÉLÉPHONE : <b>{vehicules.telephone?.toUpperCase()}</b>
            </p>
            <h2 className="text-xl font-bold">INFORMATIONS DU VÉHICULE</h2>
            <p className="text-md font-medium">
              NUMÉRO DE SÉRIE :{" "}
              <b>{vehicules.numero_serie_plaque?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              USAGE : <b>{vehicules.usage?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              TYPE/COULEUR : <b>{vehicules.couleur?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              FRANCHISE : <b>{vehicules.franchise?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              NUMÉRO DE CHÂSSIS : <b>{vehicules.chassis?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              DATE D'ÉMISSION : <b>{vehicules.date_creation?.toUpperCase()}</b>
            </p>
            <p className="text-md font-medium">
              STATION : <b>{vehicules.code_station?.toUpperCase()}</b>
            </p>

            {/* Informations de l'agent enregistreur - visible seulement pour admin */}
            {localStorage.getItem("statu") === "admin" && agentInfo && vehicules.id_enregistreur && (
              <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <h2 className="text-xl font-bold text-blue-800">INFORMATIONS DE L'AGENT ENREGISTREUR</h2>
                <p className="text-md font-medium">
                  NOM : <b>{agentInfo.nom?.toUpperCase()}</b>
                </p>
                <p className="text-md font-medium">
                  TÉLÉPHONE : <b>{agentInfo.telephone?.toUpperCase()}</b>
                </p>
                {agentInfo.details && (
                  <p className="text-md font-medium">
                    DÉTAILS : <b>{agentInfo.details?.toUpperCase()}</b>
                  </p>
                )}
                <p className="text-md font-medium">
                  SERVICE : <b>{agentInfo.service?.toUpperCase()}</b>
                </p>
              </div>
            )}

            <div></div>
          </div>
          {localStorage.getItem("statu")==="admin"||localStorage.getItem("statu")==="enregistreur"?(
          <div>
            <div className="flex flex-row justify-between items-center m-5">
              <h2 className="text-xl font-bold">QR Code du véhicule</h2>
              <button
                onClick={() => handlePrint()}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
              >
                Imprimer QR Code
              </button>
            </div>
            {/* ✅ Contenu à imprimer (Bien attaché au ref) */}
            <div
              ref={contentRef}
              className="print-wrapper"
              style={{
                width: "37mm", // Largeur de l'étiquette
                height: "42mm", // Hauteur de l'étiquette
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                backgroundColor: "#fff",

                boxSizing: "border-box",
                marginTop: "0mm",
                paddingTop: "5mm",
                // À retirer en prod
              }}
            >
              {/* Contenu principal */}
              <div
                style={{
                  width: "90%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignContent:"flex-start",
                  alignItems:"flex-start",
                  gap: "1mm",

                }}
              >
                {/* Colonne de gauche (texte) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flex: "1",
                  }}
                >
                  <div style={{ marginBottom: "1mm", marginLeft: "2mm", display: "flex", flexDirection: "row", width: "20mm", gap: "1.4mm" }}>
                    <QRCode value={vehicules.numero_serie_plaque || "Valeur manquante"} size={28} />

                    <p
                      style={{
                        fontSize: "1.3mm",
                        fontWeight: "bold",
                        marginTop: "1mm",
                        fontFamily: "Arial Black",
                        color: "#000",
                        width:"10mm",
                        overflowWrap:"break-word"
                      }}
                    >
                      {vehicules.numero_serie_plaque?.toUpperCase()}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.14mm",
                      marginLeft: "1mm",
                    }}
                  >
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicules.couleur?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicules.franchise?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                      width:"19mm",
                      overflowWrap:"break-word"
                    }}>
                      {vehicules.chassis?.toUpperCase()}
                    </p>
                  </div>
                </div>
                {/* QR Code principal (droite) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "flex-start",

                  }}
                >
                  <QRCode
                    value={encryptedData || "Valeur manquante"}
                    size={45} // Augmente la taille pour une meilleure netteté
                    level="M"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                  />
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignContent:"flex-start",
                  alignItems:"flex-start",
                  marginTop: "4mm",

                }}
              >
                {/* Colonne de gauche (texte) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flex: "1",
                  }}
                >
                  <div style={{ marginBottom: "1mm", marginLeft: "2mm", display: "flex", flexDirection: "row", width: "20mm", gap: "1.4mm" }}>
                    <QRCode value={vehicules.numero_serie_plaque|| "Valeur manquante"} size={28} />

                    <p
                      style={{
                        fontSize: "1.3mm",
                        fontWeight: "bold",
                        marginTop: "1mm",
                        fontFamily: "Arial Black",
                        color: "#000",
                        width:"10mm",
                        overflowWrap:"break-word"

                      }}
                    >
                      {vehicules.numero_serie_plaque?.toUpperCase()}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.14mm",
                      marginLeft: "1mm",
                    }}
                  >
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicules.couleur?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicules.franchise?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                      width:"19mm",
                      overflowWrap:"break-word"

                    }}>
                      {vehicules.chassis?.toUpperCase()}
                    </p>
                  </div>
                </div>
                {/* QR Code principal (droite) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "flex-start",

                  }}
                >
                  <QRCode
                    value={encryptedData || "Valeur manquante"}
                    size={45} // Augmente la taille pour une meilleure netteté
                    level="M"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                  />
                </div>
              </div>



            </div>
          </div>):<></>}
        </div>
      </div>
    </div>
  );
}
